<script setup lang="ts"></script>

<template>
  <svg width="30" height="36" viewBox="0 0 30.1974 35.25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.75 32.0658V28.6974C1.75 26.9106 2.45977 25.1971 3.72318 23.9337C4.98658 22.6703 6.70012 21.9605 8.48684 21.9605H14.3816M5.11842 8.48684C5.11842 10.2736 5.82819 11.9871 7.0916 13.2505C8.355 14.5139 10.0685 15.2237 11.8553 15.2237C13.642 15.2237 15.3555 14.5139 16.6189 13.2505C17.8823 11.9871 18.5921 10.2736 18.5921 8.48684C18.5921 6.70012 17.8823 4.98658 16.6189 3.72318C15.3555 2.45977 13.642 1.75 11.8553 1.75C10.0685 1.75 8.355 2.45977 7.0916 3.72318C5.82819 4.98658 5.11842 6.70012 5.11842 8.48684Z"
      stroke="#293D66"
      stroke-width="3.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.2763 32.0658L27.0132 25.3289M18.5921 28.6974C18.5921 30.0374 19.1245 31.3226 20.072 32.2701C21.0196 33.2177 22.3047 33.75 23.6448 33.75C24.9848 33.75 26.27 33.2177 27.2175 32.2701C28.1651 31.3226 28.6974 30.0374 28.6974 28.6974C28.6974 27.3573 28.1651 26.0722 27.2175 25.1246C26.27 24.1771 24.9848 23.6447 23.6448 23.6447C22.3047 23.6447 21.0196 24.1771 20.072 25.1246C19.1245 26.0722 18.5921 27.3573 18.5921 28.6974Z"
      stroke="#E50040"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
